// ===============================
// DONNÉES SUR L'APPROCHE D'AUDIT DES SERVICES
// ===============================

export const auditApproachHeading = {
  subtitle: "NOTRE APPROCHE D'AUDIT",
  title: "UNE MÉTHODOLOGIE D'AUDIT EN 4 ÉTAPES POUR DES INSIGHTS CLAIRS",
  description1:
    "Nous appliquons une méthodologie structurée et assistée par la technologie pour garantir que nos audits sont efficaces, perspicaces et conformes aux normes professionnelles les plus élevées.",
  description2:
    "Nous appliquons une méthodologie structurée et assistée par la technologie pour garantir que nos audits sont efficaces, perspicaces et conformes aux normes professionnelles les plus élevées.",
};

export const auditApproachSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Planification & Évaluation des Risques",
    text: "Nous comprenons votre entreprise, votre secteur et votre environnement de contrôle pour concevoir un plan d'audit basé sur les risques.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Tests & Évaluation",
    text: "Examen détaillé des données financières, des transactions et des contrôles internes à l'aide de tests analytiques et substantifs.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Revue & Analyse",
    text: "Revue complète des conclusions et des états financiers pour garantir l'exactitude et la conformité.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Reporting & Recommandations",
    text: "Fournir des insights clairs et à valeur ajoutée pour améliorer la gouvernance, l'efficacité et les processus de reporting financier.",
  },
];
export const fsaHeading = {
  subtitle: "COMMENT NOUS TRAVAILLONS",
  title: "UN CADRE D'AUDIT STRUCTURÉ EN 4 ÉTAPES POUR DES INSIGHTS CLAIRS",
  description1:
    "Un audit solide commence par comprendre pourquoi les écarts financiers se produisent, pas seulement où ils apparaissent. En utilisant des références sectorielles, nous fournissons un audit qui va au-delà des vérifications de cases et donne aux décideurs de la clarté sur la performance, la conformité et la résilience financière.",
  description2:
    "Chaque cycle d'audit est hautement collaboratif, soutenu par une communication transparente et des insights en temps opportun, garantissant que votre organisation est conforme et positionnée stratégiquement pour une croissance durable.",
};

export const fsaSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Planification & Cartographie des Risques",
    text: "Nous identifions les zones à haut risque en utilisant l'analyse des tendances, les seuils de matérialité et les références du secteur pour cibler où l'exposition financière est la plus probable.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Tests des Processus",
    text: "Nous validons les contrôles grâce à des tests d'échantillonnage, des parcours et des audits de systèmes pour que les processus fonctionnent comme d'habitude dans des conditions réelles.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Analyse des Données",
    text: "Nous appliquons des outils analytiques et des diagnostics basés sur des ratios pour détecter les incohérences et les modèles qui révèlent des lacunes opérationnelles ou de reporting.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Reporting Clair",
    text: "Nous livrons des rapports concis, prêts pour les investisseurs, décrivant les principales conclusions, les impacts financiers et les actions d'amélioration pratiques à court et long terme.",
  },
];
export const ifrsHeading = {
  subtitle: "NOTRE MÉTHODOLOGIE",
  title: "UNE APPROCHE IFRS CLAIRE, PRATIQUE ET CENTRÉE SUR L'ENTREPRISE",
  description1:
    "Chaque norme IFRS affecte plus que la comptabilité – elle influence les marges, la confiance des investisseurs, les accords, les valorisations et la façon dont la direction raconte l'histoire de l'entreprise. Nous commençons par cartographier chaque norme à vos véritables moteurs commerciaux et processus internes.",
  description2:
    "Notre équipe travaille en étroite collaboration avec vos unités financières, opérationnelles et de direction pour traduire des normes complexes en divulgations claires, des contrôles renforcés et des audits plus fluides. Ainsi, vous obtenez une visibilité plus nette sur la performance et la prise de décision dans toute l'organisation.",
};

export const ifrsSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cartographie de l'Impact",
    text: "Nous analysons comment chaque norme IFRS affecte votre modèle de revenus, vos coûts, votre trésorerie, vos KPI, vos covenants et votre communication auprès des investisseurs.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Conception des Politiques",
    text: "Nous construisons des traitements comptables sur mesure, des structures de divulgation et des plans de transition alignés sur votre secteur et votre stratégie de reporting.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Conversion Pratique",
    text: "Nous assistons pour les calculs, les retraitements, la documentation, les écritures de journal et les mises à jour des contrôles internes sur toutes les périodes de reporting.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Revue de Conformité",
    text: "Nous validons les divulgations, testons les interprétations et préparons des états prêts pour l'audit qui résistent à l'examen des régulateurs et des investisseurs.",
  },
];
export const oasHeading = {
  subtitle: "NOTRE APPROCHE D'ASSURANCE",
  title: "UNE MÉTHODOLOGIE BASÉE SUR DES PREUVES ET LA CONFIANCE DES PARTIES PRENANTES",
  description1:
    "L'assurance n'a d'importance que lorsqu'elle reflète le fonctionnement réel d'une entreprise, pas seulement comment elle est documentée. Nous étudions comment l'information circule dans les systèmes et les personnes, en ciblant l'assurance dans les domaines où l'incertitude peut devenir coûteuse.",
  description2:
    "Nous convertissons ensuite cette compréhension en tests structurés, analyses et validation qui ne laissent aucune place à l'hypothèse ou à l'estimation. Vous recevez des conclusions claires, défendables et conçues pour tenir dans les discussions du conseil, l'examen des investisseurs ou la revue réglementaire.",
};

export const oasSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Intelligence des Processus",
    text: "Nous traçons les parcours des données de bout en bout, révélant les lacunes où l'information peut s'affaiblir ou perdre en fiabilité.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Points Chauds des Risques",
    text: "Nous diagnostiquons où les contrôles échouent, où les jugements sont subjectifs et où le risque de mauvaise déclaration est le plus élevé.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Tests des Preuves",
    text: "Nous validons les chiffres, les récits, les affirmations ESG et les indicateurs opérationnels avec une vérification basée sur les données.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Reporting d'Insights",
    text: "Nous présentons les conclusions de manière claire et prête pour la prise de décision, conçue pour les conseils, les régulateurs et les parties prenantes.",
  },
];
export const icfHeading = {
  subtitle: "COMMENT NOUS RENFORÇONS",
  title: "UNE MÉTHODE STRUCTURÉE QUI AMÉLIORE ET PROTÈGE",
  description1:
    "Les contrôles solides ne se construisent pas du jour au lendemain ; ils émergent lorsque l'exposition aux risques est profondément comprise et que le comportement opérationnel est étudié de près. Nous observons comment le travail circule réellement et identifions où les contrôles échouent parce que les gens contournent les systèmes ou les systèmes ne capturent pas la réalité.",
  description2:
    "Notre équipe reconstruit ensuite votre couche de contrôle avec clarté — en définissant la propriété, les voies d'escalade, la logique d'approbation, les vérifications automatisées et les déclencheurs de reporting continu. Ensuite, vous obtenez le résultat – le contrôle qui vit à l'intérieur de votre exécution quotidienne et protège les décideurs avec certitude.",
};

export const icfSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Découverte des Processus",
    text: "Nous cartographions vos flux de travail réels. Cela nous aide à découvrir les points de contact manuels, les chevauchements d'autorité et les angles morts opérationnels.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Isolation des Risques",
    text: "Nous décomposons chaque étape critique pour identifier où les erreurs prennent naissance, où la fraude pourrait survenir et où la gouvernance s'effondre sous pression.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Ingénierie des Contrôles",
    text: "Une architecture de contrôle personnalisée est construite en utilisant des couches préventives + détectives, des vérifications automatisées dans l'ERP, des hiérarchies d'approbation et une journalisation des exceptions.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Surveillance de la Performance",
    text: "Nous mettons en place des tableaux de bord, testons les contrôles cycliquement, suivons les exceptions et recommandons des mises à jour des processus à mesure que l'entreprise évolue.",
  },
];
export const dealAdvisoryHeading = {
  subtitle: "COMMENT NOUS BLOQUONS LES TRANSACTIONS",
  title: "NOTRE APPROCHE PERSPICACE POUR DES RÉSULTATS POSITIFS",
  description1:
    "Les transactions réussissent non seulement lorsqu'elles se concluent mais lorsqu'elles se développent. Nous ne poursuivons pas les transactions ; nous évaluons le gain à long terme, l'exposition aux risques, la faisabilité des synergies et l'impact de l'intégration post-transaction.",
  description2:
    "Chaque hypothèse est remise en question, chaque valorisation testée, et chaque opportunité testée en situation de stress. Nous regardons au-delà des multiples d'EBITDA — nous mesurons la compatibilité culturelle, les frictions de trésorerie, les points de pression opérationnels et le potentiel de hausse. L'objectif est simple : soutenir la bonne transaction, pas n'importe quelle transaction.",
};

export const dealAdvisorySteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Scan de Faisabilité de la Transaction",
    text: "Nous validons le cas d'affaires dès le départ — potentiel du marché, adéquation stratégique, possibilité de synergies et perspectives de sortie avant que vous n'investissiez le moindre montant.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Analyses Financières & des Risques",
    text: "La valorisation n'est pas une opinion ; c'est une preuve. Nous décomposons les véritables moteurs de valeur, les risques à la baisse, les besoins en capital, les signaux d'alerte et testons en situation de stress les scénarios futurs.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Cartographie de la Création de Valeur",
    text: "Le succès d'une transaction = ce qui se passe après la clôture. Nous identifions les synergies post-fusion, les calendriers d'intégration, les chevauchements opérationnels et les déblocages de revenus.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Négociation & Clôture de la Transaction",
    text: "Nous structurons les termes, la logique de prix et les leviers de négociation pour que vous clôturiez depuis une position de force - protégé, préparé et orienté vers la valeur.",
  },
];
export const restructuringHeading = {
  subtitle: "CE QUE NOTRE APPROCHE DE RESTRUCTURATION DIT",
  title: "LA MÉTHODE STRUCTURÉE DERRIÈRE LES REDRESSEMENTS RÉUSSIS",
  description1:
    "La restructuration est un parcours structuré de retour à la santé. Nous diagnostiquons ce qui est cassé (trésorerie, demande, opérations ou culture), et construisons un plan de redressement qui protège la force centrale tout en réparant la colonne vertébrale faible.",
  description2:
    "La plupart des échecs ne surviennent pas par manque de solutions, mais à cause d'un séquencement médiocre et d'attentes irréalistes. Nous alignons les équipes, les prêteurs et la direction pour qu'ils avancent comme un seul — contrôlant les dégâts tôt, puis reconstruisant avec intention, discipline et des jalons mesurables.",
};

export const restructuringSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Plongée Diagnostique",
    text: "Découvrir les problèmes fondamentaux comme les boucles de trésorerie négatives, la faible utilisation, les écarts de tarification, les actifs non productifs - et construire une base de redressement propre.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Plan de Préservation de la Liquidité",
    text: "Protéger la piste de décollage grâce au déblocage rapide du fonds de roulement, aux dialogues de restructuration de la dette et aux leviers de défense des coûts opérationnels.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Feuille de Route de Redressement & de Valeur",
    text: "Repositionnement produit/marché, accélération des ventes, restructuration des dépenses et réallocation d'actifs pour restaurer une marge de manœuvre bénéficiaire.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Stabiliser pour l'Échelle",
    text: "Cadres de gouvernance, contrôles des risques et tableaux de bord de performance pour prévenir les rechutes et soutenir la croissance future.",
  },
];

export const dueDiligenceHeading = {
  subtitle: "COMMENT NOUS EXÉCUTONS LA DUE DILIGENCE",
  title: "UNE REVUE STRUCTURÉE EN 4 PHASES POUR UNE DUE DILIGENCE RÉUSSIE",
  description1:
    "Pour une due diligence réussie, on dit de ne pas se précipiter mais d'ingénier. Nous commençons par un cadrage de questions difficiles, une définition du périmètre et des protocoles d'accès aux données qui assurent la clarté avant que l'analyse ne commence.",
  description2:
    "Nous testons ensuite la vérité financière, validons la capacité opérationnelle, examinons le positionnement client et du marché, et testons en situation de stress les risques avec une réflexion de scénarios — vous donnant une image non filtrée, non polie et prête pour l'investissement.",
};

export const dueDiligenceSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Découverte Complète des Données",
    text: "Nous suivons les moteurs de revenus, interviewons les principaux dirigeants, validons les affirmations opérationnelles et signalons les incohérences tôt avant qu'elles ne créent le désordre.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Évaluation Multicouche de l'Entreprise",
    text: "Données financières, conformité, structures fiscales, exposition légale, efficacité opérationnelle - chaque domaine est décomposé pour comprendre la santé réelle de l'entreprise.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Analyse de Pression des Risques",
    text: "Que se passe-t-il si les revenus baissent de 15% ? Si les règles de conformité se resserrent ? Nous simulons des scénarios de stress commerciaux, réglementaires et basés sur la performance.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Rapport d'Intelligence de Préparation à la Transaction",
    text: "Vous recevez un briefing prêt pour la décision mettant en évidence les signaux d'alerte, les leviers de négociation, la justification de la valorisation et les défis d'intégration.",
  },
];
export const forensicHeading = {
  subtitle: "COMMENT NOUS ENQUÊTONS",
  title: "UNE MÉTHODOLOGIE FORENSIQUE CONÇUE POUR LA PREUVE",
  description1:
    "La fraude est rarement évidente. Nous commençons par analyser le comportement transactionnel, les modèles de fournisseurs, les pistes d'accès, les approbations et les voies de paiement pour détecter les incohérences que les revues traditionnelles manquent souvent. Les preuves laissent toujours des empreintes et les nombres nous aident à les tracer.",
  description2:
    "Chaque conclusion est validée, quantifiée et documentée dans un dossier d'enquête structuré conçu pour résister aux interrogations légales. Ce que vous recevez, c'est la preuve, la clarté et la direction pour agir.",
};

export const forensicSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Exploitation Profonde des Transactions",
    text: "Revue basée sur les données des grands livres, journaux, factures, contrats et pistes de communication pour établir des chronologies factuelles.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Reconstruction des Pistes",
    text: "Cartographie des flux de fonds, approbations, bénéficiaires et modèles de mauvaise conduite avec une narration forensique.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Documentation des Preuves",
    text: "Préparation de dossiers de preuves prêts pour l'audit, conformes à la loi, avec quantification des pertes et feuilles de preuves à l'appui.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Plan de Résolution & d'Action",
    text: "Support de conseil pour le recouvrement, la remédiation et la prévention de structures de fraude similaires pour un avenir sans stress.",
  },
];

export const riskAdvisoryHeading = {
  subtitle: "COMMENT NOUS RENFORÇONS",
  title: "UN CADRE D'INTELLIGENCE DES RISQUES PROACTIF",
  description1:
    "Supposons comment le risque commence ? Il commence par un signal manqué. Notre processus regarde plus profondément que les lacunes politiques, traquant les modèles de comportement, les points de pression opérationnels, l'exposition à la conformité et les déclencheurs de stress en temps réel. L'objectif n'est pas de craindre le risque, mais de le comprendre.",
  description2:
    "Comment nous changeons la situation ? Nous convertissons les indicateurs de risque en tableaux de bord mesurables, mettons en œuvre des contrôles, évaluons la force de réponse aux crises et simulons des scénarios à fort impact. Le résultat : des décisions plus rapides, des impacts contrôlés et des organisations qui restent stables même dans des conditions volatiles.",
};

export const riskAdvisorySteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cartographie de l'Évaluation des Risques",
    text: "Évaluation des contrôles internes, de l'exposition à la conformité, des flux de processus et des points de stress opérationnels de bout en bout.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Conception du Cadre",
    text: "Mise en place d'indicateurs clés de risque (ICR), de seuils de réponse, de modèles d'escalade et d'architecture de surveillance.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Mise en Œuvre des Contrôles",
    text: "Réingénierie des flux de travail, renforcement des approbations, application de points de contrôle et gouvernance basée sur les risques.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Surveillance & Revues Continues",
    text: "Supervision continue avec des audits périodiques, des tests de scénarios et des cycles d'amélioration réactifs.",
  },
];
export const techAdvisoryHeading = {
  subtitle: "COMMENT NOUS EXÉCUTONS",
  title: "UN MODÈLE DE LIVRAISON TECHNOLOGIE-VALEUR PRATIQUE",
  description1:
    "La transformation numérique échoue lorsque la technologie est mise en œuvre plus vite que les gens ne peuvent l'adopter. Notre approche commence par comprendre les frictions commerciales, les points de stress des flux de travail et le gaspillage des coûts. Ensuite, nous concevons la technologie autour de besoins réels, pas de tendances !",
  description2:
    "De plus, nous aidons les entreprises à transitionner avec clarté, gouvernons le processus de changement, quantifions l'amélioration des performances et assurons que la solution évolue à mesure que l'organisation grandit sans dépenser excessivement, sur-ingénier ou compliquer excessivement.",
};

export const techAdvisorySteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Découverte Diagnostique",
    text: "Nous découvrons les points de friction, la dette technique et les lacunes de processus grâce à des diagnostics de maturité et à une analyse d'impact commercial.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Ébauche de Solution",
    text: "Nous alignons les outils, l'architecture et le flux de données sur les objectifs commerciaux, garantissant que chaque déploiement a un objectif, un potentiel d'échelle.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Mise en Œuvre Prête pour le Changement",
    text: "Nous supervisons l'intégration, automatisons les flux de travail, gérons les fournisseurs et soutenons l'adoption des utilisateurs pour que la technologie soit adoptée — et non résistée.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Mesure de la Valeur",
    text: "Nous suivons la disponibilité, l'augmentation de la productivité, le ROI de l'automatisation et l'efficacité des coûts, affinant continuellement les systèmes pour garantir que la technologie continue de rapporter.",
  },
];

export const valuationsHeading = {
  subtitle: "NOTRE APPROCHE DE VALORISATION",
  title: "UNE MÉTHODOLOGIE QUI CORRESPOND À LA RÉALITÉ DU MARCHÉ",
  description1:
    "La valorisation ne peut pas reposer uniquement sur des hypothèses — elle nécessite du contexte, des références et des preuves. Nous commençons par des diagnostics commerciaux approfondis, une analyse de la durabilité des bénéfices, une cartographie de l'exposition aux risques et un suivi des mouvements du marché pour comprendre où la valeur est créée et où elle s'érode.",
  description2:
    "Nous étayons chaque conclusion avec des modèles transparents, des analyses comparables, des tests de scénarios et des vérifications de sensibilité, garantissant que la valeur finale résiste aux questions des investisseurs, à la revue d'audit et à la pression de négociation.",
};

export const valuationsSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Évaluation de l'Entreprise",
    text: "Analyser la stabilité des revenus, les marges, les courbes de croissance, la structure du capital et le positionnement sur le marché.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Application de Modèles",
    text: "Appliquer DCF, comparables de marché, approche revenu/coût — selon ce qui reflète le mieux la réalité économique.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Revue des Scénarios & de la Sensibilité",
    text: "Tester la valeur sous stress, le potentiel de hausse, le risque de concurrence et les facteurs d'incertitude.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Rapport de Valorisation & Présentation",
    text: "Livrer des rapports prêts pour l'audit ainsi qu'un support de présentation aux investisseurs et des insights de négociation.",
  },
];

// EN-TÊTES & ÉTAPES DE FISCALITÉ

export const corporateTaxHeading = {
  subtitle: "NAVIGUER DANS LA COMPLEXITÉ FISCALE",
  title: "EXÉCUTION STRUCTURÉE SANS AMBIGUÏTÉ",
  description1:
    "La fiscalité n'est jamais universelle — les réglementations évoluent, les interprétations changent et chaque décision impacte le profit. Nous commençons par comprendre la structure de l'entreprise, le positionnement des risques et les obligations sectorielles spécifiques pour que notre stratégie fonctionne sur des marchés réels, pas sur le papier.",
  description2:
    "L'exécution est ensuite divisée en couches actionnables telles que la documentation, le calcul, les contrôles de divulgation et le positionnement fiscal futur. Ainsi, chaque déclaration est défendable, étayée par des données et prête pour l'audit sans précipitation de dernière minute.",
};

export const corporateTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Revue de l'Interprétation Légale",
    text: "Nous décodons les réglementations changeantes et identifions les implications fiscales pertinentes pour votre entreprise.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Cartographie des Données & de la Documentation",
    text: "Les données comptables, factures, déductibles et dépenses sont évaluées pour l'éligibilité et la conformité.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Revue des Calculs & Ajustements",
    text: "Calculs fiscaux finaux effectués avec revue des déductions et ajustements basés sur les risques.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Soumission + Prêt pour l'Audit",
    text: "Déclarations, représentation et réponses aux audits gérés de bout en bout avec confiance.",
  },
];

export const mergerAcquisitionHeading = {
  subtitle: "COMMENT NOUS CONCLUONS UNE TRANSACTION",
  title: "PLANIFICATION FISCALE F&A CONFORME & TESTÉE POUR L'AVENIR",
  description1:
    "Les transactions avancent vite, et les impôts ne pardonnent pas la vitesse sans revue. Nous apportons de la structure à la complexité en évaluant les scénarios, les impacts de trésorerie, l'exposition réglementaire et les conséquences fiscales à long terme avant que les contrats ne passent à l'étape de signature.",
  description2:
    "Une fois la transaction active, notre équipe guide l'exécution à travers des revues de documentation, des modèles de prix, une cartographie fiscale d'intégration et une structuration à l'épreuve des litiges. Ceci pour garantir que votre acquisition renforce la performance plutôt que d'ajouter des fardeaux invisibles.",
};

export const mergerAcquisitionSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Analyse de Découverte",
    text: "Nous cartographions l'historique fiscal, l'exposition aux litiges et les obligations héritées pour mettre en évidence la sensibilité de la transaction.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Alignement de la Valorisation",
    text: "Impact fiscal intégré dans les modèles de prix pour éviter la surévaluation et réduire les surprises post-transaction.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Ébauche de Structuration",
    text: "Feuilles de route de transaction couvrant les formats d'achat d'actions/actifs, l'impact des plus-values et la logique de détention.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Intégration Transparente",
    text: "Consolidation post-fusion à travers les livres, les actifs, les calendriers d'amortissement et les cycles de conformité.",
  },
];

export const transferPricingHeading = {
  subtitle: "MÉTHODE DE PRIX DE TRANSFERT",
  title: "UNE MÉTHODOLOGIE QUI RÉSISTE AUX TESTS RÉGLEMENTAIRES",
  description1:
    "Le prix de transfert échoue le plus rapidement lorsqu'il semble théorique. Nous ancrons chaque politique dans le comportement commercial réel — comment vous créez de la valeur, qui contrôle le risque et où les profits appartiennent réellement. Cela signifie des stratégies qui ressemblent à votre entreprise, pas à un modèle.",
  description2:
    "Ensuite, nous vous préparons au défi, pas à la panique. Études de référence, fichiers maître/locaux, logique inter-entreprises - chaque pièce est construite pour répondre aux questions que les autorités fiscales poseront avant qu'elles ne les posent, pour que vous négociiez avec confiance au lieu de défendre de manière réactive.",
};

export const transferPricingSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Analyse des Fonctions, Actifs, Risques",
    text: "Nous cartographions comment les fonctions, les actifs et le risque se situent réellement à l'intérieur de votre entreprise — formant la base factuelle des résultats de prix.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Références & Tests Statistiques",
    text: "Ensembles comparables étayés par une justification économique, une logique sectorielle et une justification statistique — pas des fourchettes copiées-collées.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Construction de la Documentation & du Récit",
    text: "Fichier Local + Maître prêt pour l'OCDE qui explique pourquoi le prix est équitable, pas seulement ce qu'il est — rendant les audits plus fluides et plus rapides.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Préparation à l'Audit & Défense",
    text: "Lorsque les autorités contestent, nous répondons avec des faits : déclaration, support de négociation et preuves prêtes pour les litiges.",
  },
];

export const valueAddedTaxHeading = {
  subtitle: "NOTRE MÉTHODE TVA",
  title: "UNE MÉTHODE D'EXÉCUTION FISCALE PRATIQUE & PRÉVENTIVE",
  description1:
    "Chaque entreprise est exposée au risque de TVA, généralement non par négligence, mais par des écarts d'interprétation. Notre approche commence par cartographier les flux de revenus, les déclencheurs d'autoliquidation et les lacunes documentaires, garantissant que le fondement de la conformité est solide.",
  description2:
    "Une fois les contrôles établis, nous guidons la facturation, les décisions de prix, les modèles d'import/export et les déclarations continues, vous maintenant conforme sans ralentir l'entreprise. Avec des revues périodiques, des rapprochements et des conseils sur les changements de politique, la TVA devient prévisible — et non réactive.",
};

export const valueAddedTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Scan des Risques",
    text: "Nous plongeons en profondeur dans votre flux financier, découvrant les lacunes de crédit d'impôt et les expositions à la conformité.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Construction de la Documentation",
    text: "Pas de fichiers éparpillés. Pas de preuves manquantes. Nous standardisons les factures et créons une piste de transaction propre et traçable.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Conformité Continue",
    text: "Déclarations de routine, rapprochements, suivi des crédits d'entrée, mises à jour de portail, révisions réglementaires — gérées en continu.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Positionnement Prêt pour l'Audit",
    text: "Nous fournissons un support de négociation, défendons les réclamations avec des preuves documentées et réduisons le risque de litiges ou de pénalités.",
  },
];

export const internationalTaxHeading = {
  subtitle: "LA STRATÉGIE RENCONTRE LA CONFORMITÉ",
  title: "UN CADRE CLAIR QUI SIMPLIFIE LA FISCALITÉ MONDIALE",
  description1:
    "Notre méthodologie combine une compréhension réglementaire avec des insights commerciaux pratiques. Nous cartographions les passifs fiscaux, identifions les risques tôt et mettons en œuvre des structures conçues pour résister à l'examen.",
  description2:
    "Chaque engagement commence par une recherche juridictionnelle, applique une logique de traité et conclut avec des modèles qui améliorent les rendements nets tout en maintenant une conformité totale.",
};

export const internationalTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cartographie des Juridictions",
    text: "Chaque marché joue selon des règles fiscales différentes. Nous les cartographions avec précision et signalons les régions à risque avant que vous n'investissiez un seul dollar.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Analyse des Risques & de la Conformité",
    text: "Nous évaluons l'exposition BEPS, les obligations de reporting et le risque d'anti-évitement, pour que l'expansion ne vous surprenne pas plus tard.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Planification Fiscale Structurelle",
    text: "Nous concevons des structures d'entités, des flux de profits, des modèles de propriété intellectuelle et des stratégies de retenue à la source qui réduisent les fuites.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Exécution du Reporting & des Déclarations",
    text: "Le reporting signifie prouver la conformité sans friction. Des déclarations multi-pays au reporting des revenus étrangers, nous sommes votre partenaire.",
  },
];

export const exciseTaxHeading = {
  subtitle: "COMMENT NOUS NAVIGUONS L'ACCISE",
  title: "UNE STRATÉGIE STRUCTURÉE, SANS RISQUE POUR LA TAXE D'ACCISE",
  description1:
    "La taxation d'accise exige de la précision. Notre approche commence par décomposer vos flux de produits, passifs et systèmes internes pour que les résultats fiscaux deviennent prévisibles, mesurables et transparents.",
  description2:
    "Ensuite, nous mettons en œuvre des contrôles, des formats de reporting et un suivi de la conformité qui évoluent avec vos opérations. Vous restez prêt pour l'audit, à l'épreuve des pénalités et informé à tout moment — pendant que nous gérons la complexité en coulisses.",
};

export const exciseTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Diagnostic des Passifs",
    text: "Nous évaluons les catégories de produits, les droits applicables, les exemptions et les lacunes à risque pour quantifier l'exposition potentielle.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Ébauches de Cartographie Fiscale",
    text: "Matrices de taux de droits, structure de facturation, éligibilité aux exemptions et contrôles au niveau des processus construits spécifiquement pour votre entreprise.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Activation de la Conformité en Temps Réel",
    text: "Cycles de déclaration, pistes documentaires, enregistrements des mouvements de stocks et reporting — automatisés, surveillés et en temps opportun.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Gestion des Audits & Litiges",
    text: "Défendre les réclamations, préparer les soumissions, suivre les appels et clôturer les cas avec un impact financier minimum.",
  },
];

export const taxRestructuringHeading = {
  subtitle: "COMMENT NOUS RESTRUCTURONS LA FISCALITÉ",
  title: "UN CADRE PAR COUCHES POUR L'EFFICACITÉ FISCALE",
  description1:
    "La restructuration fiscale ne réarrange pas les chiffres — elle définit comment une entreprise gagne, dépense et distribue de l'argent. Nous commençons par cartographier l'architecture fiscale existante, identifier les fuites structurelles et évaluer les lacunes opérationnelles qui drainent silencieusement la rentabilité.",
  description2:
    "Une fois les expositions actuelles comprises, nous restructurons les unités commerciales, les transactions internes et les points de contact fiscaux pour des résultats optimaux. L'exécution est phasée, conforme et étayée par une documentation pour un passage en douceur avec des avantages mesurables.",
};

export const taxRestructuringSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Scan Structurel",
    text: "Revue détaillée des transactions, actifs, facturations croisées et dispositions fiscales existantes pour détecter les inefficacités.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Conception de l'Ébauche & Prévisions",
    text: "Simulation des résultats fiscaux, plans de refonte d'entités et modélisation des bénéfices à long terme avant mise en œuvre.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Mise en Œuvre & Documentation",
    text: "Exécution avec dépôts d'entreprise, dossiers de documentation, mises à jour statutaires et alignement des parties prenantes.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Surveillance & Support",
    text: "Analyse post-restructuration, cycles de revue trimestriels et ajustement fin de la conformité pour préserver les bénéfices.",
  },
];

export const economicSubstanceRegulationsHeading = {
  subtitle: "UNE MÉTHODE CLAIRETÉ D'ABORD",
  title: "DE L'ÉVALUATION À LA PREUVE – LES ÉTAPES DE L'ESR COUVERTES",
  description1:
    "La conformité ESR ne concerne pas la paperasse, mais les preuves. Nous commençons par une revue approfondie de vos opérations, activités génératrices de profits et piste de prise de décision pour identifier ce que l'autorité doit voir et ce qui manque actuellement.",
  description2:
    "Une fois les risques clairs, nous reconstruisons la documentation de substance, alignons les structures de reporting et préparons les déclarations ESR avec des preuves à l'appui. Notre mise en œuvre garantit que la conformité est durable ; pas seulement saisonnière.",
};

export const economicSubstanceRegulationsSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Diagnostic de Substance Commerciale",
    text: "Évaluation des Activités Générant des Revenus Essentiels (CIGA), du personnel, de la présence physique et de la documentation des pistes de décision.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Renforcement & Mise en Place de la Substance",
    text: "Cadres politiques, structuration des processus du conseil et alignement des activités commerciales pour une durabilité de la conformité.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Exécution des Déclarations ESR",
    text: "Préparation des notifications ESR et déclarations annuelles avec des dossiers de documentation de preuve prêts à présenter.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Cycles de Revue & Surveillance",
    text: "Vérifications trimestrielles pour assurer une conformité continue, mises à jour des politiques et préparation aux déclarations de nouvelle année.",
  },
];
export const financeAndAccountingHeading = {
  subtitle: "FAÇON DONT NOUS GÉRONS VOTRE FINANCE",
  title: "UN MODÈLE OPÉRATIONNEL EN 4 ÉTAPES QUI GARANTIT L'EXACTITUDE DE VOS LIVRES",
  description1:
    "Notre approche remplace la gestion financière éparpillée par des flux de travail structurés et à l'épreuve des erreurs. Nous prenons en charge la comptabilité quotidienne, centralisons les données, standardisons la documentation et maintenons une visibilité en temps réel.",
  description2:
    "Chaque entreprise a un rythme unique de recouvrements, de paiements, de clôtures et de reporting. Au lieu d'imposer un modèle, nous adaptons les processus, automatisons les tâches répétitives, assignons la propriété et construisons des tableaux de bord de reporting qui parlent clairement.",
};

export const financeAndAccountingSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Configuration du Flux de Travail Financier",
    text: "Nous définissons comment les factures circulent, qui approuve les paiements, ce qui est enregistré et assurons une ambiguïté zéro dans la propriété.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Gestion Comptable Quotidienne",
    text: "L'enregistrement des transactions, les rapprochements et la mise à jour des livres se font continuellement — pas une fois par mois.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Clôture Mensuelle & Reporting de Tableaux de Bord",
    text: "Nous ne préparons pas seulement des rapports ; nous mettons en évidence les modèles, les écarts, les risques de trésorerie et les mouvements de performance.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Conformité & Archives Prêtes pour l'Audit",
    text: "Les états, les pièces justificatives, les pistes fiscales et les grands livres restent propres, traçables et adaptés à l'audit.",
  },
];
export const corporateAdvisoryServicesHeading = {
  subtitle: "NOUS PILOTONS DE MEILLEURES DÉCISIONS",
  title: "NOTRE MÉTHODOLOGIE DE CONSEIL D'ENTREPRISE ÉTAPE PAR ÉTAPE",
  description1:
    "Un conseil solide commence par la clarté. Nous analysons votre position financière, la dynamique du marché, la structure de gouvernance et les défis opérationnels pour comprendre les véritables moteurs de votre décision. Cela nous permet d'identifier les risques tôt et de découvrir des opportunités qui peuvent ne pas être visibles en interne.",
  description2:
    "Nous traduisons ensuite cet insight en une stratégie basée sur des données, la faisabilité et des résultats mesurables. L'objectif est - d'équiper votre direction d'une feuille de route qui est pratique, consciente des risques et directement liée à la croissance organisationnelle.",
};

export const corporateAdvisoryServicesSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Analyse Diagnostique",
    text: "Nous évaluons les données financières, les lacunes de performance, les indicateurs du marché et les priorités stratégiques pour comprendre votre entreprise.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Modélisation des Scénarios & des Impacts",
    text: "Nous prévoyons les résultats des fusions, restructurations, expansions ou changements de capital — pour vous aider à choisir le chemin le plus fort.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Développement de l'Ébauche Stratégique",
    text: "Nous convertissons les insights en un plan d'action structuré couvrant les calendriers, les ressources, les impacts financiers et les contrôles des risques.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Supervision de la Mise en Œuvre",
    text: "Nous guidons l'exécution, suivons les progrès et affinons les stratégies à mesure que les facteurs en temps réel évoluent.",
  },
];
export const expensesClaimManagementHeading = {
  subtitle: "COMMENT NOUS TRAVAILLONS",
  title: "UN FLUX DE TRAVAIL DE DÉPENSES PRÉCIS ET ALIGNÉ SUR LES POLITIQUES",
  description1:
    "Les réclamations de dépenses restent souvent bloquées entre des politiques peu claires, des documents manquants et des approbations manuelles. Nous simplifions tout le cycle en établissant des règles claires, en numérisant les soumissions et en appliquant des couches de validation qui éliminent les litiges ou les allers-retours de communication.",
  description2:
    "Une fois vérifiées, notre équipe assure des approbations rapides, des remboursements corrects et un reporting structuré qui donne à la direction une vue plus claire des dépenses organisationnelles et des besoins budgétaires futurs.",
};

export const expensesClaimManagementSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cartographie des Politiques",
    text: "Nous alignons vos politiques existantes ou vous aidons à les redessiner pour supprimer l'ambiguïté et améliorer la conformité.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Configuration de Soumission Rationalisée",
    text: "Nous structurons les flux de travail et les modèles pour que les employés soumettent des données complètes et correctes dès la première tentative.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Couches de Vérification & d'Approvision",
    text: "Nous mettons en œuvre des vérifications à plusieurs niveaux pour assurer la conformité, prévenir la fraude et maintenir des pistes d'audit complètes.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Analyses & Insights",
    text: "Le reporting détaillé comprend les modèles de dépenses, les types de réclamations fréquents et les domaines potentiels de contrôle des coûts.",
  },
];
export const payrollHrServicesHeading = {
  subtitle: "COMMENT NOUS TRAVAILLONS",
  title: "UN PROCESSUS CONSTRUIT POUR LA TRANSPARENCE & LA CONFIANCE DES EMPLOYÉS",
  description1:
    "Nous utilisons des cycles de paie standardisés, des calculs automatisés et des flux de travail sécurisés pour garantir une exactitude totale et une conformité réglementaire. Chaque détail est vérifié grâce à un processus structuré qui réduit les erreurs et renforce la fiabilité opérationnelle.",
  description2:
    "Notre système de gestion des RH assure une intégration fluide des employés, la gestion des documents et un support continu. Avec des canaux de communication clairs, des mises à jour en temps opportun et un reporting transparent, votre main-d'œuvre expérimente un environnement RH fiable et bien organisé.",
};

export const payrollHrServicesSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cycles de Paie Automatisés",
    text: "Un cycle de paie structuré où les salaires, déductions, allocations, heures supplémentaires et avantages sont traités par validation automatisée.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Gestion Sécurisée des Données des Employés",
    text: "Tous les documents des employés, contrats, identifiants et archives RH sont stockés dans un système numérique organisé, prêt pour l'audit, avec un accès strict.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Surveillance de la Conformité",
    text: "Nous suivons les lois sur la paie, les règles WPS, les réglementations du travail et les déclarations statutaires en temps réel pour garantir que vos opérations RH restent conformes.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Tableaux de Bord de Reporting Transparents",
    text: "Vous recevez des rapports structurés — synthèses salariales, rapports d'écart, insights sur les heures supplémentaires et ventilations des coûts des employés.",
  },
];
export const secondmentHeading = {
  subtitle: "COMMENT NOUS TRAVAILLONS",
  title: "UN MODÈLE DE DÉTACHEMENT CONSTRUIT POUR L'EFFICACITÉ",
  description1:
    "Notre approche se concentre sur l'appariement du bon talent avec le bon environnement opérationnel. Nous évaluons votre charge de travail, vos exigences techniques, votre structure d'équipe et vos délais pour assigner des professionnels qui peuvent s'adapter rapidement et créer une valeur immédiate.",
  description2:
    "Une fois déployés, nos détachés suivent vos contrôles internes, cadres de reporting et culture organisationnelle pour garantir la qualité, la conformité et la transparence tout au long de la mission.",
};

export const secondmentSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cartographie des Talents",
    text: "Nous analysons vos besoins et identifions les professionnels dont les compétences, l'expérience et l'état d'esprit correspondent à vos besoins opérationnels.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Déploiement Transparent",
    text: "Nos détachés s'intègrent sans heurt dans votre espace de travail, adoptant vos systèmes et structure de reporting dès le premier jour.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Supervision de la Performance",
    text: "Nous surveillons les progrès, assurons la qualité de la livraison et fournissons des conseils continus pour maintenir une production constante.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Continuité Opérationnelle",
    text: "Vos processus restent stables et conformes, indépendamment des fluctuations de charge de travail ou des lacunes de personnel.",
  },
];
export const treasuryServiceHeading = {
  subtitle: "COMMENT NOUS TRAVAILLONS",
  title: "UN MODÈLE DE TRÉSORERIE STRUCTURÉ QUI MINIMISE LES RISQUES",
  description1:
    "Chaque organisation fait face à différentes pressions de liquidité — cycles saisonniers, volatilité sectorielle, attentes de conformité et complexité multi-banques. Notre approche commence par cartographier votre écosystème de trésorerie pour identifier les fuites de trésorerie, les lacunes de contrôle et les angles morts d'exposition.",
  description2:
    "Nous concevons ensuite un modèle opérationnel de trésorerie soutenu par des contrôles solides, des flux de travail automatisés et un reporting clair.",
};

export const treasuryServiceSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Évaluation de la Santé de la Trésorerie",
    text: "Une plongée approfondie dans les processus de trésorerie, la structure bancaire, les contrôles et les points d'exposition pour identifier les opportunités d'amélioration.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Conception du Modèle Opérationnel",
    text: "Nous définissons les cadres de gouvernance, les structures d'approbation, les contrôles des signataires et les flux de travail de trésorerie qui renforcent la supervision.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Intégration de la Mise en Œuvre & des Contrôles",
    text: "Mises à jour des mandats bancaires, configurations système, déploiements de contrôles, modèles de prévision et tableaux de bord de reporting construits pour une clarté en temps réel.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Surveillance Continue & Reporting",
    text: "Revues hebdomadaires/mensuelles, insights sur les risques et KPI de trésorerie qui assurent une gestion de la liquidité alignée sur vos objectifs commerciaux.",
  },
];
// STRATÉGIES
export const marketResearchHeading = {
  subtitle: "COMMENT NOUS TRAVAILLONS",
  title: "UN PROCESSUS DE RECHERCHE STRUCTURÉ POUR LA CROISSANCE",
  description1:
    "Les marchés évoluent vite — la technologie change, les attentes des clients évoluent et la concurrence s'intensifie...",
  description2:
    "Nous combinons des insights qualitatifs, des données quantitatives, des recherches sur le terrain et de la modélisation analytique pour construire une vue étayée par des preuves de l'opportunité.",
};

export const marketResearchSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Découverte d'Insights & Cadrage du Problème",
    text: "Nous garantissons que la recherche répond aux bonnes questions commerciales.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Collecte de Données & Intelligence du Marché",
    text: "Enquêtes, interviews, analyse des tendances et cartographie concurrentielle sont intégrées.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Modélisation d'Insights & Interprétation Stratégique",
    text: "Nous analysons les modèles et transformons les données en insights significatifs.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Recommandations & Feuille de Route Stratégique",
    text: "Direction actionnable avec des recommandations alignées sur le marché pour la prise de décision.",
  },
];

export const businessConsultingHeading = {
  subtitle: "COMMENT NOUS LIVRONS L'IMPACT",
  title: "UNE MÉTHODOLOGIE STRUCTURÉE ENRACINÉE DANS L'INSIGHT & L'ACTION",
  description1:
    "Des résultats de conseil solides commencent par comprendre ce qui se passe sous la surface. Nous examinons les processus, la dynamique du marché, la santé financière et la capacité de l'équipe pour identifier les véritables moteurs de la performance.",
  description2:
    "Ensuite, nous traduisons les insights en un plan d'action clair et structuré. Chaque recommandation est priorisée, cartographiée aux objectifs commerciaux et soutenue par des KPI mesurables pour garantir que l'exécution reste sur la bonne voie et que les résultats restent visibles.",
};

export const businessConsultingSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cartographie Diagnostique",
    text: "Identifier les angles morts opérationnels et les barrières à la croissance dans toute votre organisation.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Modélisation d'Insights",
    text: "Traduire les conclusions en insights étayés par des données et opportunités d'amélioration.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Support à la Mise en Œuvre",
    text: "Créer des cadres actionnables et guider l'exécution avec des étapes claires, une structure et une responsabilité.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Suivi de la Performance",
    text: "Guider la mise en œuvre et surveiller l'impact à travers des KPI mesurables et des cycles d'optimisation.",
  },
];

// SERVICES AUX ENTREPRISES
export const entitySetupHeading = {
  subtitle: "COMMENT NOUS SIMPLIFIONS VOTRE DÉMARRAGE",
  title: "UN PROCESSUS STRUCTURÉ POUR UNE FORMATION D'ENTITÉ RAPIDE",
  description1:
    "Chaque entité réussie commence par la clarté, pas par la paperasse. C'est pourquoi notre processus commence par analyser votre modèle d'entreprise, vos flux de revenus, vos attentes de propriété et votre empreinte à long terme. Cela nous aide à cibler la bonne structure, anticiper les frictions réglementaires et concevoir une feuille de route de formation qui accélère les approbations au lieu de les retarder.",
  description2:
    "Une fois l'ébauche verrouillée, nous exécutons la rédaction des déclarations, sécurisons les autorisations réglementaires, alignons les exigences de licence et coordonnons avec les autorités en votre nom.",
};
export const entitySetupSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Cartographie de la Mise en Place Stratégique",
    text: "Nous évaluons votre structure de propriété et vos plans opérationnels pour déterminer le modèle d'incorporation le plus efficace et conforme.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Documentation & Conformité Réglementaire",
    text: "Tous les documents juridiques, déclarations et soumissions gouvernementales sont gérés par nos experts pour garantir une approbation fluide et sans erreur.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Gestion des Licences & Enregistrements",
    text: "Nous négocions les délais, gérons les approbations et résolvons les requêtes réglementaires à travers les zones franches et juridictions offshore.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Préparation Post Mise en Place",
    text: "Une fois formée, nous livrons une entité entièrement opérationnelle ainsi que des calendriers de conformité et des essentiels de gouvernance.",
  },
];

export const outsourcedFinanceRegulatoryComplianceHeading = {
  subtitle: "UN MODÈLE OPÉRATIONNEL PLUS INTELLIGENT",
  title: "UN CADRE MÉTHODIQUE POUR DES OPÉRATIONS FINANCIÈRES SANS RISQUE",
  description1:
    "Nous commençons par un diagnostic qui cartographie vos processus financiers, cycles de reporting, obligations de conformité et risques opérationnels. Cela nous donne une image claire de ce qui fonctionne, de ce qui vous ralentit et où l'automatisation ou la restructuration peut vous faire gagner du temps.",
  description2:
    "Une fois alignés, nous déployons une équipe de support dédiée, établissons un flux de travail numérique et construisons votre calendrier de conformité. Chaque tâche est suivie, chaque délai anticipé et chaque livrable financier exécuté avec l'efficacité d'un département interne entièrement équipé.",
};

export const outsourcedFinanceRegulatoryComplianceSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Gestion Financière en Temps Réel",
    text: "Nous cartographions comment l'argent circule dans votre entreprise — qui approuve quoi et où les retards se produisent.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Déclaration Réglementaire & Reporting",
    text: "Au lieu de correctifs ponctuels, nous automatisons les tâches de routine, renforçons les contrôles et réduisons les erreurs.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Mise en Place des Contrôles Internes & de la Gouvernance",
    text: "Votre calendrier réglementaire est entièrement repris — chaque soumission et renouvellement est planifié, exécuté et documenté.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Surveillance de la Conformité & Alertes de Risque",
    text: "Nous suivons chaque changement de règle qui vous impacte, effectuons des vérifications de santé de conformité régulières et vous alertons tôt.",
  },
];

export const companySecretarialHeading = {
  subtitle: "COMMENT NOUS TRAVAILLONS",
  title: "UN PROCESSUS DE GOUVERNANCE CONSTRUIT POUR L'EXACTITUDE",
  description1:
    "Une gouvernance solide commence par la clarté, et c'est pourquoi notre processus commence par une revue complète de la position de conformité actuelle de votre entité. Nous identifions les lacunes, les archives obsolètes et les délais à venir, vous donnant une image claire de où l'attention est requise.",
  description2:
    "Une fois la stratégie alignée, nous mettons en œuvre un calendrier de gouvernance structuré, automatisons les rappels, préparons une documentation prête pour la conformité et effectuons une surveillance continue. Votre entité reste alignée sur les exigences statutaires, avec zéro stress administratif.",
};

export const companySecretarialSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Évaluation de la Conformité de l'Entité",
    text: "Nous examinons les registres existants, déclarations, procès-verbaux de réunion et documents pour cartographier les lacunes et risques de conformité.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Configuration du Calendrier de Gouvernance",
    text: "Tous les délais annuels, obligations du conseil et exigences de déclaration sont organisés dans un calendrier de conformité proactif.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Exécution de la Documentation & des Déclarations",
    text: "Avis, résolutions, procès-verbaux, formulaires statutaires - tout est rédigé, mis à jour et soumis avec précision.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Surveillance Continue & Conseil",
    text: "Nous suivons les changements réglementaires, maintenons des archives à jour et fournissons un support continu pour les requêtes de gouvernance.",
  },
];